// extracted by mini-css-extract-plugin
export default {"formHeader":"Signup_formHeader__EH-ea","formBoldText":"Signup_formBoldText__-K5in","aText":"Signup_aText__VW-tN","termLink":"Signup_termLink__oi52k"};